import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import accountingAppReducer from './duck/legado/accountingApp';
import analiticDataReducer from './duck/legado/accountingApp/analiticData';
import accountingAppReducerV2 from './duck/legado/accountingAppV2';
import closedDataReducer from './duck/legado/accountingAppV2/closedData';
import analyticReportCsvReportReducer from './duck/legado/analyticReportCsv';
import apurationAppReducer from './duck/legado/apurationApp';
import cashInAnalyticReducer from './duck/legado/cashin/analyticData';
import cashInDownloadReducer from './duck/legado/cashin/downloadData';
import cashInSyntheticReducer from './duck/legado/cashin/syntheticData';
import clientsAppReducer from './duck/legado/clientsApp';
import customersDocumentsReducer from './duck/legado/clientsApp/customersDocuments';
import clientsFilterReducer from './duck/legado/clientsApp/filter';
import getSingleReducer from './duck/legado/clientsApp/single';
import dashboardReducer from './duck/legado/dashboardApp';
import boletoFaresReducer from './duck/legado/faresApp/boletosFares';
import cartaoFaresReducer from './duck/legado/faresApp/cartaoFares';
import criptoFaresReducer from './duck/legado/faresApp/criptoFares';
import domicilioFaresReducer from './duck/legado/faresApp/domicilioFares';
import faresFilterReducer from './duck/legado/faresApp/filter';
import incomeReducer from './duck/legado/faresApp/Income';
import monthlyFaresReducer from './duck/legado/faresApp/monthlyFares';
import pixFaresReducer from './duck/legado/faresApp/pixFares';
import slbFaresReducer from './duck/legado/faresApp/slbFares';
import tedFaresReducer from './duck/legado/faresApp/tedFares';
import tevFaresReducer from './duck/legado/faresApp/tevFares';
import tibFaresReducer from './duck/legado/faresApp/tibFares';
import legadoAuthReducer from './duck/legado/legadoAuth';
import LimitAppReducer from './duck/legado/limitApp';
import LimitFilterReducer from './duck/legado/limitApp/filter';
import outstandingDebitsAppReducer from './duck/legado/outstandingDebitsApp';
import outstandingDebitsFilterReducer from './duck/legado/outstandingDebitsApp/filter';
import transfersAppReducer from './duck/legado/transferApp';
import transfersFilterReducer from './duck/legado/transferApp/filter';
import authReducer from './duck/loginPage/loginAuth';
import partnerDataReducer from './duck/productsPage/partnerData';
import productsReducer from './duck/productsPage/products';
import profileAuthReducer from './duck/productsPage/profileAuth';
import profileReducer from './duck/productsPage/profileData';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
  immutableCheck: false,
});

const store = configureStore({
  reducer: {
    loginAuth: authReducer,
    products: productsReducer,
    userProfile: profileReducer,
    profileAuth: profileAuthReducer,
    legadoAuth: legadoAuthReducer,
    clientsApp: clientsAppReducer,
    transfersApp: transfersAppReducer,
    transfersFilterApp: transfersFilterReducer,
    clientsFilter: clientsFilterReducer,
    clientsDocuments: customersDocumentsReducer,
    clientSingle: getSingleReducer,
    partnerProfile: partnerDataReducer,
    dashboard: dashboardReducer,
    tedFares: tedFaresReducer,
    boletoFares: boletoFaresReducer,
    monthlyFares: monthlyFaresReducer,
    tibFares: tibFaresReducer,
    slbFares: slbFaresReducer,
    pixFares: pixFaresReducer,
    criptoFares: criptoFaresReducer,
    domicilioFares: domicilioFaresReducer,
    tevFares: tevFaresReducer,
    cartaoFares: cartaoFaresReducer,
    faresFilter: faresFilterReducer,
    cashInAnalytic: cashInAnalyticReducer,
    cashInSynthetic: cashInSyntheticReducer,
    cashInDownload: cashInDownloadReducer,
    incomeFares: incomeReducer,
    outstandigDebitsFilter: outstandingDebitsFilterReducer,
    outstandingDebitsApp: outstandingDebitsAppReducer,
    limitFilter: LimitFilterReducer,
    limitsApp: LimitAppReducer,
    accountingApp: accountingAppReducer,
    accountingAppV2: accountingAppReducerV2,
    analyticReportCsvReport: analyticReportCsvReportReducer,
    analiticData: analiticDataReducer,
    closedData: closedDataReducer,
    apurationAppData: apurationAppReducer,
  },
  middleware: customizedMiddleware,
});

export type IReducer = ReturnType<typeof store.getState>;
export default store;
